import React from "react";
import getStoreStatus from "../storeLocator/utils/getStoreStatus";
import { OpeningHour } from "@storeLocator/storeType";
interface OpenClosingTimeProps {
  storeHours: OpeningHour[];
}
const OpenclosingTime = ({ storeHours }: OpenClosingTimeProps) => {
  const { status, nextAction } = getStoreStatus(storeHours, new Date());
  return (
    <span>
      {status} {nextAction}
    </span>
  );
};

export default OpenclosingTime;
